import { t } from '../i18n.js';

function bars(values, maxHint) {
  const max = Math.max(...values, maxHint || 1);
  return `<div class="chart-bars">${values.map((v) => {
    const h = Math.max(4, Math.round((v / max) * 72));
    return `<div class="bar" style="height:${h}px" title="${v.toFixed ? v.toFixed(1) : v}"></div>`;
  }).join('')}</div>`;
}

export function renderEnvironment(root, state) {
  const lang = state.lang;
  const e = state.env;
  root.innerHTML = `
    <div class="view">
      <h2 class="view-title">${t(lang, 'env')}</h2>
      <div class="grid grid-3">
        <div class="card">
          <h3>溫度（室內多點＋外）</h3>
          <div class="meta">點 1 / 2 / 3 · 室外</div>
          <div class="stat-value big">${e.indoorTemp.map((x) => x.toFixed(1)).join(' · ')} °C</div>
          <div class="stat-row"><span class="stat-label">室外</span><span class="stat-value">${e.outdoorTemp.toFixed(1)} °C</span></div>
          ${bars(e.history.temp, 35)}
        </div>
        <div class="card">
          <h3>濕度</h3>
          <div class="stat-value big">${e.indoorHumidity.join(' · ')} %</div>
          <div class="stat-row"><span class="stat-label">室外</span><span class="stat-value">${e.outdoorHumidity} %</span></div>
          ${bars(e.history.humidity, 100)}
        </div>
        <div class="card">
          <h3>CO₂（只偵測）</h3>
          <div class="stat-value big">${e.co2Ppm} ppm</div>
          <div class="meta">無增補閥 — 超標只警報</div>
          ${bars(e.history.co2, 2000)}
        </div>
        <div class="card">
          <h3>光照</h3>
          <div class="stat-value big">${Math.round(e.lightLux).toLocaleString()} lux</div>
        </div>
        <div class="card">
          <h3>雨量</h3>
          <div class="stat-value big">${e.rainMmH} mm/h</div>
        </div>
        <div class="card">
          <h3>風速</h3>
          <div class="stat-value big">${e.windMs.toFixed(1)} m/s</div>
          <div class="meta">≥12 m/s 觸發風速警報鎖窗邏輯</div>
        </div>
      </div>
    </div>
  `;
}
